/* RebelOneMart — Elite Quick Add
   Save as: assets/rom-elite-quick-add.js
*/
(function () {
  var state = {
    selectedVariantId: null,
    activeProduct: null
  };

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = d['cart-drawer'];
          var newCd = tmp.querySelector('cart-drawer');
          var existingCd = document.querySelector('cart-drawer');
          if (newCd && existingCd) {
            existingCd.classList.toggle('is-empty', newCd.classList.contains('is-empty'));
          }
          var newInner = tmp.querySelector('.drawer__inner');
          var existingInner = document.querySelector('cart-drawer .drawer__inner');
          if (newInner && existingInner) existingInner.innerHTML = newInner.innerHTML;
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        }
        if (d && d['cart-icon-bubble']) {
          var tmp2 = document.createElement('div');
          tmp2.innerHTML = d['cart-icon-bubble'];
          var fresh = tmp2.querySelector('#cart-icon-bubble') || tmp2.firstElementChild;
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && fresh) bubble.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {});
  }

  function getModal() {
    return document.getElementById('rom-quick-add-modal');
  }

  function getBody() {
    return document.getElementById('rom-eqa-body');
  }

  function lockScroll() {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  function openModal() {
    var modal = getModal();
    if (!modal) return;
    modal.hidden = false;
    modal.classList.add('is-open');
    lockScroll();
  }

  function closeModal() {
  var modal = getModal();
  if (!modal) return;

  modal.hidden = true;
  modal.classList.remove('is-open');

  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';

  state.selectedVariantId = null;
  state.activeProduct = null;
}

  function firstAvailableVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }
    return product.variants[0];
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

    function formatVariantLabel(rawTitle) {
    return String(rawTitle || '')
        .replace(/women'?s high tops/ig, 'Women')
        .replace(/women'?s low tops/ig, 'Women')
        .replace(/women'?s mid tops/ig, 'Women')
        .replace(/women'?s slip[- ]?ons/ig, 'Women')
        .replace(/women'?s boots/ig, 'Women')
        .replace(/women'?s slides?(?:\s*&\s*sandals?)?/ig, 'Women')
        .replace(/womens high tops/ig, 'Women')
        .replace(/womens low tops/ig, 'Women')
        .replace(/womens mid tops/ig, 'Women')
        .replace(/womens slip[- ]?ons/ig, 'Women')
        .replace(/womens boots/ig, 'Women')
        .replace(/womens slides?(?:\s*&\s*sandals?)?/ig, 'Women')
        .replace(/men'?s high tops/ig, 'Men')
        .replace(/men'?s low tops/ig, 'Men')
        .replace(/men'?s mid tops/ig, 'Men')
        .replace(/men'?s slip[- ]?ons/ig, 'Men')
        .replace(/men'?s boots/ig, 'Men')
        .replace(/men'?s slides?(?:\s*&\s*sandals?)?/ig, 'Men')
        .replace(/mens high tops/ig, 'Men')
        .replace(/mens low tops/ig, 'Men')
        .replace(/mens mid tops/ig, 'Men')
        .replace(/mens slip[- ]?ons/ig, 'Men')
        .replace(/mens boots/ig, 'Men')
        .replace(/mens slides?(?:\s*&\s*sandals?)?/ig, 'Men')
        .replace(/\s*\/\s*/g, ' / ')
        .trim();
    }

    function getToast() {
    return document.getElementById('rom-added-toast');
    }

    function showToast() {
    var toast = getToast();
    if (!toast) return;

    toast.hidden = false;

    requestAnimationFrame(function () {
        toast.classList.add('is-visible');
    });

    clearTimeout(window.__romToastTimer);
    window.__romToastTimer = setTimeout(function () {
        toast.classList.remove('is-visible');

        setTimeout(function () {
        toast.hidden = true;
        }, 220);
    }, 1800);
    }

  // Returns unique values for a given option index across all variants
  function uniqueOptionValues(product, optionIndex) {
    var seen = {};
    var values = [];
    for (var i = 0; i < product.variants.length; i++) {
      var val = product.variants[i]['option' + (optionIndex + 1)];
      if (val && !seen[val]) { seen[val] = true; values.push(val); }
    }
    return values;
  }

  // Find variant matching the currently selected option values
  function findVariant(product, selections) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var match = true;
      for (var k = 0; k < selections.length; k++) {
        if (v['option' + (k + 1)] !== selections[k]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  // Check if any variant with given option value at optionIndex is available
  function anyAvailableForOption(product, optionIndex, value) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v['option' + (optionIndex + 1)] === value && v.available) return true;
    }
    return false;
  }

  // Check availability for a value given other already-selected options
  function isAvailableGivenSelections(product, optionIndex, value, selections) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (!v.available) continue;
      if (v['option' + (optionIndex + 1)] !== value) continue;
      var compatible = true;
      for (var k = 0; k < selections.length; k++) {
        if (k === optionIndex) continue;
        if (selections[k] !== null && v['option' + (k + 1)] !== selections[k]) {
          compatible = false;
          break;
        }
      }
      if (compatible) return true;
    }
    return false;
  }

  // Return option name string whether options are objects or strings
  function optionName(opt) {
    return typeof opt === 'object' ? opt.name : opt;
  }

  // Detect if product is a jacket+pants set
  function isJacketPantsProduct(product) {
    if (!product.options) return false;
    return product.options.some(function(opt) {
      var n = optionName(opt).toLowerCase();
      return n.indexOf('jacket') !== -1 || n.indexOf('pants') !== -1;
    });
  }

  var SHOE_RE = /shoe|sneaker|high tops|low tops|mid tops|slip[- ]?on|boots|slides/i;

  // Detect a shoe so we only relabel COLOR -> Insole Color on footwear,
  // never on apparel where Color means the garment's actual color.
  function isShoeProduct(product) {
    var tags = product.tags || [];
    var tagStr = (Array.isArray(tags) ? tags.join(' ') : String(tags));
    if (SHOE_RE.test(tagStr)) return true;
    if ((product.type || '').match(/shoe|sneaker|boot|footwear/i)) return true;
    if (product.variants) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        if (SHOE_RE.test([v.option1, v.option2, v.option3].join(' '))) return true;
      }
    }
    return false;
  }

  // The size shapes the size finder reads (readSize in rom-size-converter.js). A shoe sold in other shapes, such as a slide's
  // "Youth 3", has no finder on its page, so the modal doesn't point there.
  var FINDER_SIZES = [/^[\d.]+ Men \/ [\d.]+ Women$/, /^Men [\d.]+ \/ Women [\d.]+$/, /^(?:(?:Men|Women)[\s/]*)?US ?[\d.]+ ?[(/] ?EU ?[\d.]+\)?$/];

  // Sizes here are buttons without the chart, so a shoe with a size choice gets a way to its page's size finder.
  // Not on a single final-sale pair: its size is fixed.
  function sizeFinderLink(product, values) {
    if (!isShoeProduct(product) || hasTag(product, 'discounted shoes') || values.length < 2) return '';
    var readable = values.every(function (v) {
      return FINDER_SIZES.some(function (rx) { return rx.test(String(v).trim()); });
    });
    if (!readable) return '';
    return '<a class="rom-eqa__sizeLink" href="/products/' + escapeHtml(product.handle) + '#find-your-size">' +
      'Not sure which size? <span>Find your size on the full page.</span></a>';
  }

  // On the product page itself (the sticky bar opens this modal there), open the page's own size tab instead of reloading it.
  function goToSizeFinder(event, handle) {
    var onPage = window.location.pathname.split('/products/')[1] === handle;
    var pageLink = onPage && document.querySelector('.product__info-container [data-rom-size-link]');
    closeModal();
    if (pageLink) {
      event.preventDefault();
      pageLink.click();
    }
  }

  // First variant carrying a given option value that has an image (for swatches)
  function imageForOptionValue(product, optionIndex, value) {
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v['option' + (optionIndex + 1)] === value && v.featured_image) {
        return v.featured_image.src;
      }
    }
    return null;
  }

  function setModalImage(body, src) {
    if (!src) return;
    var imgEl = body.querySelector('.rom-eqa__image');
    if (imgEl) imgEl.src = src;
  }

  function renderProduct(product, preVariantId) {
    state.activeProduct = product;
    state.selectedVariantId = null;

    var body = getBody();
    if (!body) return;

    var featured = '';
    if (product.featured_image) {
      featured =
        '<div class="rom-eqa__imageWrap">' +
        '<img class="rom-eqa__image" src="' + escapeHtml(product.featured_image) +
        '" alt="' + escapeHtml(product.title) + '">' +
        '</div>';
    }

    var isMultiOption = product.options && product.options.length > 1;
    var optionsHtml = '';

    var shoe = isShoeProduct(product);

    if (isMultiOption) {
      // Only show the "set" note for jacket/pants products, not shoes
      if (isJacketPantsProduct(product)) {
        optionsHtml += '<p class="rom-eqa__multi-note">This is a set — choose a size for each piece below.</p>';
      }
      // Render one labeled group per option
      for (var o = 0; o < product.options.length; o++) {
        var optName = optionName(product.options[o]);
        var values = uniqueOptionValues(product, o);
        var isColor = optName.toLowerCase().indexOf('color') !== -1;
        // On footwear the Color option is the insole color, shown as image swatches
        var asSwatch = shoe && isColor;

        optionsHtml += '<div class="rom-eqa__optGroup" data-rom-group-idx="' + o + '">';
        optionsHtml += '<div class="rom-eqa__optLabel">' +
          escapeHtml(asSwatch ? 'Insole Color' : optName) + '</div>';
        if (asSwatch) {
          optionsHtml += '<div class="rom-eqa__optCaption">Tap a color to preview it above — this is the insole color.</div>';
        }
        if (optName.toLowerCase().indexOf('size') !== -1) {
          optionsHtml += sizeFinderLink(product, values);
        }
        optionsHtml += '<div class="rom-eqa__variants rom-eqa__variants--opt' +
          (asSwatch ? ' rom-eqa__variants--swatch' : '') +
          '" data-rom-opt-index="' + o + '">';
        for (var vi = 0; vi < values.length; vi++) {
          var available = anyAvailableForOption(product, o, values[vi]);
          if (asSwatch) {
            var swSrc = imageForOptionValue(product, o, values[vi]);
            optionsHtml +=
              '<button type="button" class="rom-eqa__variant rom-eqa__variant--swatch" data-rom-opt-index="' + o +
              '" data-rom-opt-value="' + escapeHtml(values[vi]) + '"' +
              (available ? '' : ' disabled') + '>' +
              (swSrc ? '<img class="rom-eqa__swatchImg" src="' + escapeHtml(swSrc) + '" alt="' + escapeHtml(values[vi]) + '" loading="lazy">' : '') +
              '<span class="rom-eqa__swatchName">' + escapeHtml(values[vi]) + '</span>' +
              '</button>';
          } else {
            optionsHtml +=
              '<button type="button" class="rom-eqa__variant" data-rom-opt-index="' + o +
              '" data-rom-opt-value="' + escapeHtml(values[vi]) + '"' +
              (available ? '' : ' disabled') + '>' +
              escapeHtml(values[vi]) + '</button>';
          }
        }
        optionsHtml += '</div></div>';
      }
    } else {
      // Single option — original flat variant buttons
      optionsHtml = '<div class="rom-eqa__label">Choose your size</div>' +
        sizeFinderLink(product, (product.variants || []).map(function (v) { return v.option1; })) +
        '<div class="rom-eqa__variants">';
      if (product.variants && product.variants.length) {
        for (var i = 0; i < product.variants.length; i++) {
          var variant = product.variants[i];
          var rawTitle = variant.public_title || variant.title || 'Option ' + (i + 1);
          var title = formatVariantLabel(rawTitle);
          optionsHtml +=
            '<button type="button" class="rom-eqa__variant" data-rom-variant-id="' + variant.id + '"' +
            (variant.available ? '' : ' disabled') + '>' +
            escapeHtml(title) + '</button>';
        }
      }
      optionsHtml += '</div>';
    }

    if (hasTag(product, 'add a name')) {
      optionsHtml =
        '<a class="rom-eqa__nameLink" href="/products/' + escapeHtml(product.handle) + '#rom-add-a-name">' +
        'Want a name on these? <span>Add it on the full page, +$10.</span></a>' +
        optionsHtml;
    }

    body.innerHTML =
      '<div class="rom-eqa__grid">' +
        featured +
        '<div>' +
          '<h3 class="rom-eqa__title">' + escapeHtml(product.title) + '</h3>' +
          '<p class="rom-eqa__price">' + money(product.price) + '</p>' +
        '</div>' +
      '</div>' +
      optionsHtml +
      '<div class="rom-eqa__actions">' +
        '<button type="button" class="rom-eqa__add" id="rom-eqa-add" disabled>Add to Cart</button>' +
        '<a class="rom-eqa__view" href="/products/' + escapeHtml(product.handle) + '">View full details</a>' +
      '</div>';

    var addBtn = body.querySelector('#rom-eqa-add');

    var nameLink = body.querySelector('.rom-eqa__nameLink');
    if (nameLink) {
      nameLink.addEventListener('click', function (event) {
        goToNameBox(event, this, product.handle);
      });
    }

    var sizeLink = body.querySelector('.rom-eqa__sizeLink');
    if (sizeLink) {
      sizeLink.addEventListener('click', function (event) {
        goToSizeFinder(event, product.handle);
      });
    }

    if (isMultiOption) {
      var selections = new Array(product.options.length).fill(null);

      function updateAddBtn() {
        var allSelected = selections.every(function (s) { return s !== null; });
        if (!allSelected) { addBtn.disabled = true; return; }
        var matched = findVariant(product, selections);
        addBtn.disabled = !(matched && matched.available);
        if (matched) state.selectedVariantId = matched.id;
      }

      // Index of the Color option, used as an image fallback when a specific
      // style/size variant (e.g. Women's) has no image of its own assigned.
      var colorIdx = -1;
      for (var ci = 0; ci < product.options.length; ci++) {
        if (optionName(product.options[ci]).toLowerCase().indexOf('color') !== -1) { colorIdx = ci; break; }
      }

      // Swap the header photo to reflect the current selection so the
      // chosen color (insole) is always visible.
      function updateImage() {
        var matched = findVariant(product, selections);
        if (matched && matched.featured_image) {
          setModalImage(body, matched.featured_image.src);
          return;
        }
        // Fallback 1: any variant matching all current selections that has an image
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          if (!v.featured_image) continue;
          var ok = true;
          for (var k = 0; k < selections.length; k++) {
            if (selections[k] !== null && v['option' + (k + 1)] !== selections[k]) { ok = false; break; }
          }
          if (ok) { setModalImage(body, v.featured_image.src); return; }
        }
        // Fallback 2: any variant sharing the selected color that has an image
        // (covers products where only one style, e.g. Men's, carries the photos)
        if (colorIdx !== -1 && selections[colorIdx] !== null) {
          for (var j = 0; j < product.variants.length; j++) {
            var cv = product.variants[j];
            if (cv.featured_image && cv['option' + (colorIdx + 1)] === selections[colorIdx]) {
              setModalImage(body, cv.featured_image.src);
              return;
            }
          }
        }
      }

      // Refresh disabled state on all buttons in every OTHER group.
      // Only upstream selections (index < g) constrain group g's availability —
      // a size choice should never disable a style option.
      function refreshOtherGroups(changedIdx) {
        for (var g = 0; g < product.options.length; g++) {
          if (g === changedIdx) continue;
          var gRef = g; // capture for forEach closure
          body.querySelectorAll('.rom-eqa__variant[data-rom-opt-index="' + gRef + '"]').forEach(function(btn) {
            var val = btn.getAttribute('data-rom-opt-value');
            // Build partial selections: only use choices from groups upstream of gRef
            var partialSel = selections.map(function(s, idx) {
              return idx < gRef ? s : null;
            });
            var avail = isAvailableGivenSelections(product, gRef, val, partialSel);
            btn.disabled = !avail;
            if (!avail && btn.classList.contains('is-active')) {
              btn.classList.remove('is-active');
              selections[gRef] = null;
            }
          });
        }
      }

      var optBtns = body.querySelectorAll('.rom-eqa__variant[data-rom-opt-index]');
      optBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (this.disabled) return;
          var idx = Number(this.getAttribute('data-rom-opt-index'));
          var val = this.getAttribute('data-rom-opt-value');
          body.querySelectorAll('.rom-eqa__variant[data-rom-opt-index="' + idx + '"]')
            .forEach(function (b) { b.classList.remove('is-active'); });
          this.classList.add('is-active');
          selections[idx] = val;
          refreshOtherGroups(idx);
          updateAddBtn();
          updateImage();
        });
      });

      // Pre-select: use preVariantId if supplied, otherwise first available per group
      var preVariant = preVariantId
        ? product.variants.filter(function(v) { return v.id === preVariantId; })[0]
        : null;

      for (var p = 0; p < product.options.length; p++) {
        var preVal = preVariant ? preVariant['option' + (p + 1)] : null;
        if (preVal) {
          var preBtn = body.querySelector('.rom-eqa__variant[data-rom-opt-index="' + p + '"][data-rom-opt-value="' + preVal.replace(/"/g, '\\"') + '"]:not([disabled])');
          if (preBtn) { preBtn.classList.add('is-active'); selections[p] = preVal; continue; }
        }
        var groupBtns = body.querySelectorAll('.rom-eqa__variant[data-rom-opt-index="' + p + '"]:not([disabled])');
        if (groupBtns.length) {
          groupBtns[0].classList.add('is-active');
          selections[p] = groupBtns[0].getAttribute('data-rom-opt-value');
        }
      }
      // Single initial refresh: sizes reflect pre-selected style, styles stay selectable
      refreshOtherGroups(-1);
      updateAddBtn();
      updateImage();

    } else {
      var variantButtons = body.querySelectorAll('.rom-eqa__variant');
      variantButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          variantButtons.forEach(function (b) { b.classList.remove('is-active'); });
          this.classList.add('is-active');
          var vid = Number(this.getAttribute('data-rom-variant-id'));
          state.selectedVariantId = vid;
          if (addBtn) addBtn.disabled = false;
          var sv = product.variants.filter(function (v) { return v.id === vid; })[0];
          if (sv && sv.featured_image) setModalImage(body, sv.featured_image.src);
        });
      });

      // Pre-select: use preVariantId if supplied, otherwise first available
      var toSelect = preVariantId
        ? product.variants.filter(function(v) { return v.id === preVariantId; })[0]
        : firstAvailableVariant(product);
      if (!toSelect) toSelect = firstAvailableVariant(product);
      if (toSelect) {
        var initialBtn = body.querySelector('[data-rom-variant-id="' + toSelect.id + '"]');
        if (initialBtn && !initialBtn.disabled) {
          initialBtn.classList.add('is-active');
          state.selectedVariantId = toSelect.id;
          if (addBtn) addBtn.disabled = false;
          if (toSelect.featured_image) setModalImage(body, toSelect.featured_image.src);
        }
      }
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (!state.selectedVariantId) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';
        addBtn.style.opacity = '0.7';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: state.selectedVariantId, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart error');
            return res.json();
          })
          .then(function (item) {
            // The size finder on this page notes what was added, if the shopper opened it (assets/rom-size-converter.js).
            document.dispatchEvent(new CustomEvent('rom:quick-add', { detail: item }));
            addBtn.textContent = 'Added ✓';
            refreshCartDrawer();
            setTimeout(function () { closeModal(); showToast(); }, 220);
          })
          .catch(function (err) {
            console.error(err);
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
            addBtn.style.opacity = '1';
          });
      });
    }
  }

  function hasTag(product, tag) {
    var tags = product.tags || [];
    var list = Array.isArray(tags) ? tags : String(tags).split(',');
    return list.some(function (t) { return String(t).trim().toLowerCase() === tag; });
  }

  // Custom listings need the design box on the product page, which the modal does not have.
  function isCustomListing(product) {
    return hasTag(product, 'custom listing');
  }

  // The name box stays on the product page, where the photos and the rules are, so a name has one way into the cart.
  // The sticky bar opens this modal on the product page itself: there it just jumps up to the box, unless the modal
  // picked a different pair, which needs the page to load with that variant.
  function goToNameBox(event, link, handle) {
    var variantId = state.selectedVariantId;
    var tick = document.querySelector('[data-rom-name-tick]');
    var pageVariant = tick && tick.closest('form').querySelector('[name="id"]');
    var onPage = window.location.pathname.split('/products/')[1] === handle;
    closeModal();
    if (onPage && pageVariant && (!variantId || pageVariant.value === String(variantId))) {
      event.preventDefault();
      if (!tick.checked) tick.click();
      tick.closest('[data-rom-name]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (variantId) link.href = '/products/' + handle + '?variant=' + variantId + '#rom-add-a-name';
  }

  function goToDesignBox(handle) {
    closeModal();
    var box = document.getElementById('rom-custom-design');
    if (box && window.location.pathname.indexOf('/products/' + handle) !== -1) {
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var field = box.querySelector('textarea');
      if (field) field.focus({ preventScroll: true });
      return;
    }
    window.location.href = '/products/' + handle + '#rom-custom-design';
  }

  function loadProduct(handle, preVariantId) {
    var body = getBody();
    if (!body) return;

    body.innerHTML = '<div class="rom-eqa__loading">Loading...</div>';
    openModal();

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product error');
        return res.json();
      })
      .then(function (product) {
        if (isCustomListing(product)) {
          goToDesignBox(product.handle);
          return;
        }
        renderProduct(product, preVariantId || null);
      })
      .catch(function () {
        body.innerHTML =
          '<div class="rom-eqa__message">Error loading product</div>';
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = event.target.closest('.rom-quick-add-btn');

      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) {
          event.stopImmediatePropagation();
        }

        var handle = trigger.getAttribute('data-product-handle');
        if (handle && trigger.getAttribute('data-rom-custom') === 'true') {
          goToDesignBox(handle);
          return;
        }
        if (handle) {
          loadProduct(handle);
        }
        return;
      }

      if (event.target.closest('[data-rom-eqa-close]')) {
        closeModal();
      }
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  // Public API — used by the sticky ATC bar
  window.romEliteQA = {
    open: function(handle, preVariantId) {
      if (handle) loadProduct(handle, preVariantId || null);
    }
  };
})();